import { TextField, TextFieldProps } from './text-field';
import { ReactNode } from 'react';
import { FieldValues } from 'react-hook-form';

interface PhoneFieldProps<T extends FieldValues> extends Omit<TextFieldProps<T>, 'label'> {
  label?: ReactNode;
}

export const PhoneField = <T extends FieldValues>({ label = 'Phone', ...props }: PhoneFieldProps<T>) => {
  return <TextField<T> label={label} {...props} />;
};
